import { Controller } from "react-hook-form";
import { Textarea } from "@/components/ui/textarea";
import { FieldShell, type FieldComponentProps } from "./field-shell";

export function LongTextField({
  field,
  control,
  disabled,
}: FieldComponentProps) {
  if (field.kind !== "long_text") return null;
  return (
    <Controller
      name={field.name}
      control={control}
      render={({ field: f, fieldState }) => (
        <FieldShell
          id={f.name}
          label={field.label}
          required={field.required}
          helpText={field.helpText}
          error={fieldState.error?.message}
        >
          <Textarea
            id={f.name}
            value={f.value == null ? "" : String(f.value)}
            onChange={(e) => f.onChange(e.target.value)}
            onBlur={f.onBlur}
            placeholder={field.placeholder}
            maxLength={field.maxLength}
            rows={4}
            disabled={disabled}
            aria-invalid={!!fieldState.error}
          />
        </FieldShell>
      )}
    />
  );
}
